"use strict";

var __makeTemplateObject = this && this.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }
  return cooked;
};
var __createBinding = this && this.__createBinding || (Object.create ? function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  var desc = Object.getOwnPropertyDescriptor(m, k);
  if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
    desc = {
      enumerable: true,
      get: function () {
        return m[k];
      }
    };
  }
  Object.defineProperty(o, k2, desc);
} : function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  o[k2] = m[k];
});
var __setModuleDefault = this && this.__setModuleDefault || (Object.create ? function (o, v) {
  Object.defineProperty(o, "default", {
    enumerable: true,
    value: v
  });
} : function (o, v) {
  o["default"] = v;
});
var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
  __setModuleDefault(result, mod);
  return result;
};
var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.EntityPreview = exports.EntityPreviewDefaultProps = void 0;
var react_1 = __importDefault(require("react"));
var styled_components_1 = __importStar(require("styled-components"));
var theme_1 = require("@shapeable/theme");
var utils_1 = require("@shapeable/utils");
var ui_1 = require("@shapeable/ui");
var entity_menu_1 = require("./entity-menu");
var use_modal_1 = require("../../hooks/use-modal");
var entity_modal_form_route_1 = require("./entity-modal-form-route");
var use_entity_definition_named_1 = require("../../hooks/use-entity-definition-named");
var current_user_can_1 = require("../../utils/current-user-can");
var lodash_1 = require("lodash");
var cls = (0, utils_1.classNames)('entity-preview');
exports.EntityPreviewDefaultProps = {};
// -------- Styles -------->
var ContainerStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    width: 100%;\n  "], ["\n    width: 100%;\n  "])))
});
var RendererStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n    width: 100%;\n  "], ["\n    width: 100%;\n  "])))
});
var PostLayoutStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n    width: 100%;\n  "], ["\n    width: 100%;\n  "])))
});
var MenuStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n    /* find a better way to do this... argh */\n    position: absolute;\n    left: -120px;\n  "], ["\n    /* find a better way to do this... argh */\n    position: absolute;\n    left: -120px;\n  "])))
});
// -------- Components -------->
var My = {
  Container: styled_components_1.default.div(templateObject_5 || (templateObject_5 = __makeTemplateObject(["", ""], ["", ""])), ContainerStyles),
  Menu: (0, styled_components_1.default)(entity_menu_1.EntityMenu)(templateObject_6 || (templateObject_6 = __makeTemplateObject(["", ""], ["", ""])), MenuStyles),
  Renderer: (0, styled_components_1.default)(ui_1.PageRenderer)(templateObject_7 || (templateObject_7 = __makeTemplateObject(["", ""], ["", ""])), RendererStyles),
  PostLayout: (0, styled_components_1.default)(ui_1.PostLayout)(templateObject_8 || (templateObject_8 = __makeTemplateObject(["", ""], ["", ""])), PostLayoutStyles)
};
var EntityPreview = function (props) {
  var className = props.className,
    children = props.children,
    entity = props.entity;
  var defn = (0, use_entity_definition_named_1.useEntityDefinitionNamed)('Slice');
  var modal = (0, use_modal_1.useModal)();
  var onMenuButtonClick = function (event, entity) {
    console.log(entity);
    modal.show(react_1.default.createElement(entity_modal_form_route_1.EntityModalUpdateFormRoute, {
      onSubmit: function (entity) {
        modal.hide();
      },
      onCancel: function () {
        modal.hide();
      },
      id: entity.id,
      definition: defn
    }));
  };
  var entityTypeName = (0, utils_1.entityTypeNameFor)(entity);
  if (!(0, lodash_1.includes)(['Page', 'Post'], entityTypeName)) {
    // only supported for page?
    return null;
  }
  var transformEntityPath = function (entity) {
    if ((0, utils_1.entityTypeNameFor)(entity) === 'Page') {
      return "/pages/".concat(entity.slug, "/preview");
    }
    return "".concat(entity.upath, "/preview");
  };
  var sliceLayoutProps = (0, current_user_can_1.currentUserCanAdmin)() ? {
    onMenuButtonClick: onMenuButtonClick,
    menuButtonTitle: 'Edit Slice'
  } : {};
  return react_1.default.createElement(My.Container, {
    className: cls.name(className)
  }, react_1.default.createElement(ui_1.PageEntityProvider, {
    value: entity
  }, react_1.default.createElement(ui_1.ThemeProvider, {
    theme: "DEFAULT"
  }, react_1.default.createElement(ui_1.AppStateProvider, null, react_1.default.createElement(ui_1.UiProvider, {
    value: {
      header: {},
      search: {
        isAvailable: false
      },
      componentProps: {
        SliceLayout: sliceLayoutProps
      }
    }
  }, react_1.default.createElement(ui_1.EntityPathDeriverProvider, {
    value: transformEntityPath
  }, react_1.default.createElement(ui_1.DefaultPageLayoutProvider, {
    value: ui_1.PageLayoutStandard
  }, entityTypeName === 'Page' && react_1.default.createElement(My.Renderer, {
    entity: entity
  }), entityTypeName === 'Post' && react_1.default.createElement(My.PostLayout, {
    entity: entity
  }))))))));
};
exports.EntityPreview = EntityPreview;
exports.EntityPreview.defaultProps = exports.EntityPreviewDefaultProps;
exports.EntityPreview.cls = cls;
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6, templateObject_7, templateObject_8;